





import Vue from 'vue';
import {Component} from 'vue-property-decorator';

@Component
export default class OidcCallbackView extends Vue {

    public oidcSignInCallback() {
        return this.$store.dispatch('oidcStore/oidcSignInCallback');
    }

    public mounted() {
        this.oidcSignInCallback()
            .then(redirectPath => {
                this.$router.push(redirectPath);
            })
            .catch(err => {
                this.$router.push('/oidc-callback-error'); // Handle errors any way you want
            });
    }
}
